import { UserDTO } from '../../../../models/userDTO';

export const SUPPLIER_ADMINISTRATION_MODIFY = 'SUPPLIER_ADMINISTRATION_MODIFY';
export const ADDRESS_ADMINISTRATION_MODIFY = 'ADDRESS_ADMINISTRATION_MODIFY';

type PermissionLike = string | { code?: string };

type UserWithOptionalPermissions = UserDTO & {
	permissions?: PermissionLike[];
	permissionCodes?: string[];
	role?: UserDTO['role'] & {
		permissions?: PermissionLike[];
	};
}

const addressAdministrationRoles = new Set([
	'ADMIN',
	'TECH',
	'ADMIN_TECH',
	'PHF_SIEGE_ADMIN',
	'EL_USER',
	'EL_LIMITED',
	'EL_ADMIN',
	'EL_PROSPECT',
]);

const collectPermissionCodes = (user?: UserWithOptionalPermissions) => {
	const codes = new Set<string>();
	const addPermission = (permission: PermissionLike) => {
		if (typeof permission === 'string') codes.add(permission);
		else if (permission.code) codes.add(permission.code);
	};

	user?.permissions?.forEach(addPermission);
	user?.permissionCodes?.forEach((permission) => codes.add(permission));
	user?.role?.permissions?.forEach(addPermission);

	return codes;
};

export const hasAdministrationPermission = (user: UserDTO | undefined, permission: string) => {
	const userWithPermissions = user as UserWithOptionalPermissions | undefined;
	const permissionCodes = collectPermissionCodes(userWithPermissions);

	if (permissionCodes.size > 0) {
		return permissionCodes.has(permission);
	}

	const roleCode = userWithPermissions?.role?.code || userWithPermissions?.extended_role;

	if (permission === SUPPLIER_ADMINISTRATION_MODIFY) {
		return roleCode === 'ADMIN';
	}

	if (permission === ADDRESS_ADMINISTRATION_MODIFY) {
		return roleCode ? addressAdministrationRoles.has(roleCode) : false;
	}

	return false;
};
